import {addProductToFavourites} from '../api/products';

export const TOGGLE_FAVOURITE = 'toggle.favourite';
export const CLASS_ACTIVE = 'active';

/**
 *
 * @param {Event & { currentTarget: HTMLButtonElement }} event
 */
const handlerClick = async ({currentTarget: button}) => {
    const {id} = button.dataset;

    button.disabled = true;

    const status = await addProductToFavourites(id);

    if (status) {
        button.classList.toggle(CLASS_ACTIVE);
        button.dispatchEvent(new CustomEvent(TOGGLE_FAVOURITE));
    }

    button.disabled = false;
}

/**
 *
 * @param {HTMLButtonElement} button
 */
export default function createButtonFavourite(button) {
    button.addEventListener('click', handlerClick);
}
